import React, { createContext, useState, useEffect } from "react";
import axios from "utils/axios";
import { BASE_URL, USER_ROLE } from "utils/Constants";
import { getUser } from "./JWTContext";
import { RegionPrice, HandlerContextType } from '../types/helper';

// Create Context
export const HandlerContext = createContext<HandlerContextType | null>(null);

// Create Provider Component
export const HandlerProvider = ({ children }: { children: React.ReactElement }) => {
    const [regionPrices, setRegionPrices] = useState<RegionPrice[]>([]);

    useEffect(() => {
        const serviceToken = window.localStorage.getItem("serviceToken");
        const { _id, role } = getUser(serviceToken || '');
        if (_id && role === USER_ROLE.USER) {
            fetchData()
        }

        const handleVisibilityChange = () => {
            if (document.visibilityState === 'visible') {
                fetchData();
            }
        };

        const handleFocus = () => {
            fetchData();
        };


        document.addEventListener('visibilitychange', handleVisibilityChange);
        window.addEventListener('focus', handleFocus);

        return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
            window.removeEventListener('focus', handleFocus);
        };
    }, [])

    const fetchData = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/api/shop/get-region-prices`);
            setRegionPrices(response.data?.data || []);
        } catch (err) {
            console.error("Error fetching data:", err);
            setRegionPrices([]);
        }
    };

    return (
        <HandlerContext.Provider value={{ fetchData, regionPrices }}>
            {children}
        </HandlerContext.Provider>
    );
};
